// Copyright (c) 2016 Deere & Company

import AttachmentClaim from '@deere/cps-it.warranty-model-factory/lib/claim-attachment';

export const getUpdatedAttachmentClaim = (currentClaim, selectedAction) =>
    AttachmentClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/attachment/services/update-attachment-claim.js